import { defineSchema } from '../../schema-meta.ts';
import { registerCategorySchema } from '../../registry.ts';
import { QUEST_TYPE } from '../../enum-registry.ts';

export const QuestMilestoneSchema = defineSchema({
  name: 'serverQuestMilestones',
  fields: [
    ['id', 'number'],
    ['questType', { kind: 'enum', name: 'QuestType', members: QUEST_TYPE }],
    ['rewards', { kind: 'dict', dict: 'delivery' }],
    // requiredCount is appended LAST so pre-reseed (3-field) tuples still decode
    // `rewards` correctly; missing trailing slot decodes to undefined and the
    // server gate fail-closes until the category is re-seeded.
    ['requiredCount', 'number'],
  ],
  lookupKeys: ['id'],
});

export interface RawQuestMilestoneRow {
  id: number;
  quest_type: string;
  required_count: number;
  rewards: Record<string, number>;
}

export function questMilestoneFromRaw(row: RawQuestMilestoneRow) {
  return {
    id: row.id,
    questType: row.quest_type,
    // Coerce in case Supabase serializes the count as a string (NUMERIC).
    // Mirrors the client builder's toInt(r.required_count).
    requiredCount: Number(row.required_count),
    rewards: row.rewards,
  };
}

registerCategorySchema('serverQuestMilestones', QuestMilestoneSchema);
